module.exports = __webpack_public_path__ + "assets/loops.c5ba02cf.svg";